import React, { memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import BusinessTypePage from './BusinessTypePage';
import { dataCaptureSelectors, saveBusinessTypeForm } from '../../store/dataCapture';
import { BUSINESS_TYPE_PAGE } from '../../utils/constants';

const BusinessTypeSection = memo(function BusinessTypeSection({
  bankId,
  brandId,
  saveBusinessTypeForm,
  getBusinessData
}) {
  return (
    <BusinessTypePage
      brandId={brandId}
      bankId={bankId}
      saveBusinessTypeForm={saveBusinessTypeForm}
      backClick={this.businessBack}
      getBusinessData={getBusinessData}
    />
  );
});

BusinessTypeSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveBusinessTypeForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveBusinessTypeForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: dataCaptureSelectors.getBusinessData(state, BUSINESS_TYPE_PAGE)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BusinessTypeSection);
